import { IConfig } from "@kuika/kuika-cl-model";
import { IScreenDesignContextState } from "../../contexts/screen-design-context/screen-design-context";
import type { ScreenDesignInstance } from "./designer-context";
import { getValues } from "./designer-context";

interface ISaveScreenSuccess {
  success: true;
  message: string;
}

interface IRunPreviewSuccess {
  success: true;
  message: string;
}

interface IRunPreviewError {
  error: string;
}

function getScreenProvider(sd: IScreenDesignContextState): IScreenDesignContextState {
  return sd;
}

function getCurrentScreenName(sd: IScreenDesignContextState): string | null {
  return sd?.sdName || sd?.getScreenDesign?.()?.name || null;
}

export async function saveDesignerScreen(
  sdInstance: ScreenDesignInstance,
  input: { withValidation?: boolean; newName?: string } = {}
): Promise<ISaveScreenSuccess> {
  const sd = getValues(sdInstance);
  await getScreenProvider(sd).saveScreen(input.withValidation ?? true, input.newName);

  const suffix = input.newName ? ` as "${input.newName}"` : ` "${getCurrentScreenName(sd) || "current screen"}"`;
  return { success: true, message: `Saved screen${suffix}` };
}

export async function runDesignerPreview(
  sdInstance: ScreenDesignInstance
): Promise<IRunPreviewSuccess | IRunPreviewError> {
  const sd = getValues(sdInstance);
  const configurations: IConfig[] = sd?.configurations || [];
  const runConfig = configurations.find((configuration: IConfig) => configuration.isRunConfig);

  if (!runConfig) {
    return { error: "No run configuration found. Please configure run settings in App Settings." };
  }
  if (configurations.length === 0) {
    return { error: "No configurations available." };
  }

  sd.setCodeGenerationTypeAndPublish(0, runConfig, "6");
  return {
    success: true,
    message: "Preview triggered. The project is being built and will open in a new tab when ready."
  };
}
